import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SystemSection from './components/SystemSection';
import Stakeholders from './components/Stakeholders';
import NotAnApp from './components/NotAnApp';
import WaitlistForm from './components/WaitlistForm';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Header />
        <main>
          <Hero />
          <SystemSection />
          <Stakeholders />
          <NotAnApp />
          <WaitlistForm />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;